import { render } from "./SearchApp.vue?vue&type=template&id=682a3d03&scoped=true"
import script from "./SearchApp.vue?vue&type=script&lang=js"
export * from "./SearchApp.vue?vue&type=script&lang=js"

import "./SearchApp.vue?vue&type=style&index=0&id=682a3d03&lang=sass&scoped=true"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682a3d03"]])

export default __exports__